var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{'simulation-page-form': !_vm.noScroll}, {'simulation-page-form-no-scroll': _vm.noScroll}],attrs:{"id":_vm.anchor}},[_c('div',{staticClass:"simulation-page-container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }